import { Injector, ProviderToken } from '@angular/core';

export class ServiceLocator {
  private static injector?: Injector;

  /**
   * Получить
   */
  static get<T>(token: ProviderToken<T>): T | undefined {
    return ServiceLocator.injector?.get<T>(token);
  }

  /**
   * Инициализация
   */
  static init(_injector: Injector): void {
    this.injector = _injector;
  }
}
